import { SINGLE_SCAN_FAILURE, SINGLE_SCAN_REQUEST, SINGLE_SCAN_SUCCESS } from "../constants/scanConstants";

export const singleScanRequest = (oemId, search = '') => ({
  type: SINGLE_SCAN_REQUEST,
  payload: { oemId, search }
});

export const singleScanSuccess = (data) => ({
  type: SINGLE_SCAN_SUCCESS,
  payload: data
});

export const singleScanFailure = (error) => ({
  type: SINGLE_SCAN_FAILURE,
  payload: error
});